<template>
  <router-view/>
</template>

<script>
//import Home from './components/Home.vue'

export default {
  /* name: 'App',
  components: {
    Home
  }, */
  mounted() {
    //let externalScript = document.getElementById("tmpScript");
    /* let aa = document.createElement('script');
    aa.setAttribute('src', 'https://code.jquery.com/jquery-3.5.1.slim.min.js');
    aa.setAttribute('integrity', 'sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj');
    aa.setAttribute('crossorigin', 'anonymous');
    externalScript.appendChild(aa);

    let bb = document.createElement('script');
    bb.setAttribute('src', 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/js/bootstrap.bundle.min.js');
    bb.setAttribute('integrity', 'sha384-Piv4xVNRyMGpqkS2by6br4gNJ7DXjqk09RmUpJ8jgGtD7zP9yug3goQfGII0yAns');
    bb.setAttribute('crossorigin', 'anonymous');
    externalScript.appendChild(bb);

    let cc = document.createElement('link');
    cc.setAttribute('href', 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css');
    cc.setAttribute('integrity', 'sha384-B0vP5xmATw1+K9KRQjQERJvTumQW0nPEzvF6L/Z6nronJ3oUOFUFpCjEUQouq2+l');
    cc.setAttribute('crossorigin', 'anonymous');
    cc.setAttribute('rel', 'stylesheet');
    document.head.appendChild(cc); */

    /* var tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', '../vendor/jquery/jquery.min.js');
    externalScript.appendChild(tmpScript);

    tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', '../vendor/bootstrap/js/bootstrap.bundle.min.js');
    externalScript.appendChild(tmpScript);

    tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', '../js/front.js');
    externalScript.appendChild(tmpScript);

    tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', '../vendor/lightbox2/js/lightbox.min.js');
    externalScript.appendChild(tmpScript);

    tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', './vendor/nouislider/nouislider.min.js');
    externalScript.appendChild(tmpScript);

    tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', '../vendor/bootstrap-select/js/bootstrap-select.min.js');
    externalScript.appendChild(tmpScript);

    tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', '../vendor/owl.carousel2/owl.carousel.min.js');
    externalScript.appendChild(tmpScript);

    tmpScript = document.createElement('script');
    tmpScript.setAttribute('src', '../vendor/owl.carousel2.thumbs/owl.carousel2.thumbs.min.js');
    externalScript.appendChild(tmpScript); */
  },
}
</script>

<style scoped>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }
</style>
